export enum EActionStatus {
  Initial = 'Initial',
  Success = 'Success',
  Error = 'Error',
  Failure = 'Failure',
  Pending = 'Pending',
}
